module.exports = __webpack_public_path__ + "static/muñoz-784c29337183b6f278f4a0fef1b71cb1.png";